import React, { Component } from 'react'
import './Menu.css'
import ToggleMenu from '../../containers/ToggleMenu'
import $ from "jquery"


class Menu extends Component {
  constructor(props) {
    super(props)
    this.menuItems = props.menuItems;
  }

  componentDidMount(state) {
    $('body').attr('id', 'arts')
    $('body').addClass('arts-secondary-layer-on')
    $('.secondary:visible li:first-child a').addClass('layer-on')
  }

  componentWillReceiveProps(state) {
    // set active menu
    $('body').attr('id', state.section)
  }



 render() {
  return(
   <ul className="menu">
    { this.menuItems.map((item, i) =>
      <ToggleMenu key={i} id={ item.id + '-secondary' } item={ item } itemChildren={ item.children } />
    )}
  </ul>
 )
}

}
export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js